import React from 'react'
import { find, isBlank } from 'lodash'
import Select from 'UI/Select'
import { Row, Col } from 'react-bootstrap'

const defaultFilters = {
  systemTypes: 'All',
  operatingSystems: 'All',
  functions: 'All',
  regions: 'All',
  customers: 'All',
  inCloudCore: 'All'
}

const Filters = ({ filterOptions, filters, changeFilters }) => (
  <Row className='mb-4'>
    <Col>
      <label>Customer Region</label>
      <Select
        isMulti
        value={filters.regions}
        options={filterOptions.regions}
        onChange={options => changeFilters({ ...filters, regions: isBlank(options) ? 'All' : options })}
      />
    </Col>

    <Col>
      <label>Customers</label>
      <Select
        isMulti
        value={filters.customers}
        options={filterOptions.customers}
        onChange={options => changeFilters({ ...filters, customers: isBlank(options) ? 'All' : options })}
      />
    </Col>

    <Col>
      <label>In CloudCore</label>
      <Select
        value={find(filterOptions.inCloudCore, ['value', filters.inCloudCore])}
        options={filterOptions.inCloudCore}
        onChange={option => changeFilters({ ...filters, inCloudCore: option.value })}
      />
    </Col>

    <Col>
      <label>OS</label>
      <Select
        isMulti
        value={filters.operatingSystems}
        options={filterOptions.operatingSystems}
        onChange={options => changeFilters({ ...filters, operatingSystems: isBlank(options) ? 'All' : options })}
      />
    </Col>

    <Col>
      <label>System Type</label>
      <Select
        isMulti
        value={filters.systemTypes}
        options={filterOptions.systemTypes}
        onChange={options => changeFilters({ ...filters, systemTypes: isBlank(options) ? 'All' : options })}
      />
    </Col>
  </Row>
)

export { Filters, defaultFilters }
